<template>
  <div>
    <div class="mb-1 d-flex flex-row">
      <div style="flex:1;" class="pr-2">
        <h6 style="color: #101010;">
          {{ $l('form_header_bizSet') || '业务设置' }}
        </h6>
      </div>
    </div>

    <el-form
      ref="baseForm"
      :model="formData"
      size="mini"
      label-position="top"
      :disabled="enableEdit || disabled"
    >
      <div class="d-flex">
        <div class="flex-grow-1">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('form_label_financialRiskAssessment') || '财务风险评估'
                "
              >
                <el-input
                  :value="
                    formData.v_riskLevel ||
                      $l('form_label_financialRiskAssessment_N') ||
                      '待评估'
                  "
                  readonly
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_paymentTerms') || '默认付款条件'"
              >
                <dict-select
                  v-model="formData.paymentTerms"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'paymentTerms' }"
                  :placeholder="
                    $l('form_placeholder_paymentTerms') || '请选择默认付款条件'
                  "
                  style="width: 100%"
                  size="mini"
                  filterable
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('form_label_discountSalesAmount') || '货款结算是否包含佣金'
                "
              >
                <el-select
                  v-model="formData.discountSalesAmount"
                  :placeholder="
                    $l('form_placeholder_discountSalesAmount') ||
                      '请选择货款结算是否包含佣金'
                  "
                  filterable
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    value="Y"
                    :label="
                      $l('form_label_discountSalesAmount_Y') || '包含佣金'
                    "
                  />
                  <el-option
                    value="N"
                    :label="
                      $l('form_label_discountSalesAmount_N') || '不包含佣金'
                    "
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="margin-left: 10px;" v-if="!disabled">
          <el-form-item>
            <template #label>
              <div>
                <br />
              </div>
            </template>
            <div class="d-flex justify-content-end">
              <el-button
                size="mini"
                type="primary"
                :disabled="enableEdit"
                @click="saveCust()"
              >
                {{ $l('INDEX.btn_save') || '保存' }}
              </el-button>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>

    <div class="pt-3 pb-1">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <h6 class="m-0">
            {{ $l('form_header_takeOrder') || '接单抬头设置' }}
          </h6>
          <el-divider direction="vertical" v-if="!disabled" />
          <b-button
            v-if="!disabled"
            size="sm"
            variant="outline-success"
            @click="addTakeOrder"
            :disabled="enableEdit"
          >
            {{ $l('btn_addTakeOrder') || '新增接单设置' }}
          </b-button>
        </div>
        <div>
          <vxe-button
            size="mini"
            circle
            @click="getTakeOrderData()"
            :disabled="enableEdit"
          >
            <i class="vxe-button--icon vxe-icon--refresh" />
          </vxe-button>
        </div>
      </div>

      <div class="cust-takeOrder-list">
        <el-form
          v-for="(form, index) in listTakeOrder"
          :key="index"
          ref="takeOrder-form"
          :model="form"
          :rules="takeOrderRules"
          size="mini"
          label-position="top"
          :disabled="!form.enableEdit"
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_takeOrderOrgCode') || '接单抬头设置'"
                prop="takeOrderOrgCode"
              >
                <dict-select
                  v-model="form.takeOrderOrgCode"
                  :selectedLabel.sync="form.takeOrderOrgName"
                  :placeholder="
                    $l('form_placeholder_takeOrderOrg') || '请选择接单抬头设置'
                  "
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'takeOrderOrgCode' }"
                  clearable
                  filterable
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_takeOrderOrgName') || '收汇抬头'"
              >
                <el-input v-model="form.takeOrderOrgName" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <template #label>
                  <div><br /></div>
                </template>
                <div
                  class="text-right"
                  v-if="!enableEdit && !form.enableEdit && !disabled"
                >
                  <el-tooltip
                    effect="dark"
                    :content="$l('INDEX.btn_tips_del') || '删除'"
                    placement="top"
                  >
                    <i
                      class="el-icon-delete text-danger tool-btn"
                      @click="deleteTakeOrder(form)"
                    />
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    :content="$l('INDEX.btn_tips_edit') || '编辑'"
                    placement="top"
                  >
                    <i
                      class="el-icon-edit tool-btn"
                      @click="editTakeOrder(form)"
                    />
                  </el-tooltip>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_takeOrderType') || '订单类型限制'"
                prop="takeOrderType"
              >
                <dict-select
                  v-model="form.takeOrderType"
                  :placeholder="
                    $l('form_placeholder_takeOrderType') || '请选择订单类型限制'
                  "
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'takeOrderType' }"
                  clearable
                  filterable
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_executeOrgCode') || '国内业务执行公司'"
                prop="executeOrgCode"
              >
                <dict-select
                  v-model="form.executeOrgCode"
                  :selectedLabel.sync="form.executeOrgName"
                  :placeholder="
                    $l('form_placeholder_executeOrg') ||
                      '请选择国内业务执行公司'
                  "
                  url="/digitalCenter/common/dict/system"
                  :body="{ dictType: 'takeOrderOrgCode' }"
                  clearable
                  filterable
                  size="mini"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="
                  $l('form_label_executeOrgName') || '国内公司采购合同甲方抬头'
                "
              >
                <el-input v-model="form.executeOrgName" readonly />
              </el-form-item>
            </el-col>
          </el-row>
          <div
            v-if="form.enableEdit && !disabled"
            class="my-2 d-flex justify-content-end"
          >
            <el-button size="small" @click="cancelEditTakeOrder(index)">
              {{ $l('INDEX.btn_cancel') || '取消' }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="saveTakeOrder(form, index)"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-form>
        <EmptyContent v-if="!listTakeOrder || !listTakeOrder.length" />
      </div>
    </div>

    <div class="pt-3 pb-1">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <div class="d-flex align-items-center">
          <h6 class="m-0">{{ $l('form_header_bank') || '客户银行账号' }}</h6>
          <el-divider direction="vertical" v-if="!disabled" />
          <b-button
            v-if="!disabled"
            size="sm"
            variant="outline-success"
            @click="addBank"
            :disabled="enableEdit"
          >
            {{ $l('btn_addBank') || '新增银行账号' }}
          </b-button>
        </div>
        <div>
          <vxe-button
            size="mini"
            circle
            @click="getBankData()"
            :disabled="enableEdit"
          >
            <i class="vxe-button--icon vxe-icon--refresh" />
          </vxe-button>
        </div>
      </div>

      <div class="cust-bank-list">
        <el-form
          v-for="(form, index) in listBank"
          :key="index"
          ref="bank-form"
          :model="form"
          :rules="bankRules"
          size="mini"
          label-position="top"
          :disabled="!form.enableEdit"
        >
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_bankName') || '开户银行'"
                prop="bankName"
              >
                <el-input
                  v-model="form.bankName"
                  :placeholder="
                    $l('form_placeholder_bankName') || '请输入开户银行'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_bankAccountType') || '账户性质'"
                prop="bankAccountType"
              >
                <el-select
                  v-model="form.bankAccountType"
                  :placeholder="
                    $l('form_placeholder_bankAccountType') || '请选择账户性质'
                  "
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    value="0"
                    :label="$l('form_label_bankAccountType_0') || '公司'"
                  />
                  <el-option
                    value="1"
                    :label="$l('form_label_bankAccountType_1') || '个人'"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                :label="$l('form_label_bankAccountKind') || '账号类别'"
                prop="bankAccountKind"
              >
                <dict-select
                  v-model="form.bankAccountKind"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'bankAccountKind' }"
                  :placeholder="
                    $l('form_placeholder_bankAccountKind') || '请选择账号类别'
                  "
                  size="mini"
                  clearable
                  filterable
                />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <template #label>
                  <div style="width: 100px;"><br /></div>
                </template>
                <div
                  class="text-right"
                  v-if="!enableEdit && !form.enableEdit && !disabled"
                >
                  <el-tooltip
                    effect="dark"
                    :content="$l('INDEX.btn_tips_del') || '删除'"
                    placement="top"
                  >
                    <i
                      class="el-icon-delete text-danger tool-btn"
                      @click="deleteBank(form)"
                    />
                  </el-tooltip>
                  <el-tooltip
                    effect="dark"
                    :content="$l('INDEX.btn_tips_edit') || '编辑'"
                    placement="top"
                  >
                    <i class="el-icon-edit tool-btn" @click="editBank(form)" />
                  </el-tooltip>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_bankAccountName') || '账户名称'"
                prop="bankAccountName"
              >
                <el-input
                  v-model="form.bankAccountName"
                  :placeholder="
                    $l('form_placeholder_bankAccountName') || '请输入账户名称'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$l('form_label_bankAccountNo') || '银行账号'"
                prop="bankAccountNo"
              >
                <el-input
                  v-model="form.bankAccountNo"
                  :placeholder="
                    $l('form_placeholder_bankAccountNo') || '请输入银行账号'
                  "
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <div
            v-if="form.enableEdit && !disabled"
            class="my-2 d-flex justify-content-end"
          >
            <el-button size="small" @click="cancelEditBank(index)">
              {{ $l('INDEX.btn_cancel') || '取消' }}
            </el-button>
            <el-button
              type="primary"
              size="small"
              @click="saveBank(form, index)"
            >
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </div>
        </el-form>
        <EmptyContent v-if="!listBank || !listBank.length" />
      </div>
    </div>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import EmptyContent from '../empty-content'
const initTakeOrder = { enableEdit: true }
const initBank = { enableEdit: true }
export default {
  components: { EmptyContent },
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      formData: {},
      listTakeOrder: [],
      currTakeOrder: {},
      listBank: [],
      currBank: {},
      takeOrderRules: {
        takeOrderOrgCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderOrg') || '请选择接单抬头设置',
            trigger: 'change',
          },
        ],
        takeOrderType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderType') || '请选择订单类型限制',
            trigger: 'change',
          },
        ],
        executeOrgCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_executeOrg') ||
              '请选择国内业务执行公司',
            trigger: 'change',
          },
        ],
      },
      bankRules: {
        bankName: [
          {
            required: true,
            message: this.$l('form_placeholder_bankName') || '请输入开户银行',
            trigger: 'blur',
          },
        ],
        bankAccountType: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountType') || '请选择账户性质',
            trigger: 'change',
          },
        ],
        bankAccountKind: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountKind') || '请选择账号类别',
            trigger: 'change',
          },
        ],
        bankAccountName: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountName') || '请输入账户名称',
            trigger: 'blur',
          },
        ],
        bankAccountNo: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bankAccountNo') || '请输入银行账号',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    enableEdit() {
      return (
        this.listTakeOrder.some((item) => !!item.enableEdit) ||
        this.listBank.some((item) => !!item.enableEdit)
      )
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getCustData()
      this.getTakeOrderData()
      this.getBankData()
    },
    async getCustData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerV2DetailApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      this.formData = res.body
    },
    async getTakeOrderData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerTakeOrderListApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body?.data || []
      this.listTakeOrder = data.map((item) => ({ ...item, enableEdit: false }))
    },
    async getBankData() {
      if (!this.custCode) return
      const res = await this.$api
        .masterCustomerBankListApi({ custCode: this.custCode })
        .catch(() => null)
      if (!res) return
      const data = res.body?.data || []
      this.listBank = data.map((item) => ({ ...item, enableEdit: false }))
    },
    addTakeOrder() {
      this.listTakeOrder.push({ ...initTakeOrder })
      this.currTakeOrder = null
    },
    async deleteTakeOrder({ custTakeOrderCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerTakeOrderDelApi({ custTakeOrderCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getTakeOrderData()
    },
    async editTakeOrder(takeOrder) {
      if (this.enableEdit) return
      this.currTakeOrder = JSON.parse(JSON.stringify(takeOrder))
      takeOrder.enableEdit = true
    },
    async saveTakeOrder(takeOrder, index) {
      if (
        !(await validate.formValidate([this.$refs['takeOrder-form'][index]]))
      ) {
        return
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerTakeOrderSaveApi({
          ...takeOrder,
          custCode: this.custCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getTakeOrderData()
    },
    cancelEditTakeOrder(index) {
      if (!this.currTakeOrder) {
        this.listTakeOrder.splice(index, 1)
      } else {
        this.$set(this.listTakeOrder, index, { ...this.currTakeOrder })
      }
    },
    addBank() {
      this.listBank.push({ ...initBank })
      this.currBank = null
    },
    async deleteBank({ custBankCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBankDelApi({ custBankCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getBankData()
    },
    editBank(bank) {
      if (this.enableEdit) return
      this.currBank = JSON.parse(JSON.stringify(bank))
      bank.enableEdit = true
    },
    async saveBank(bank, index) {
      if (!(await validate.formValidate([this.$refs['bank-form'][index]]))) {
        return
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBankSaveApi({ ...bank, custCode: this.custCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getBankData()
    },
    cancelEditBank(index) {
      if (!this.currBank) {
        this.listBank.splice(index, 1)
      } else {
        this.$set(this.listBank, index, { ...this.currBank })
      }
    },
    async saveCust() {
      const params = {
        custCode: this.custCode,
        paymentTerms: this.formData.paymentTerms,
        discountSalesAmount: this.formData.discountSalesAmount,
        isMain: 'Y',
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerSaveFinanceApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getCustData()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .cust-takeOrder-list,
  .cust-bank-list {
    .tool-btn {
      font-size: 20px;
    }
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
